import { render } from "./TestimonialsComp.vue?vue&type=template&id=b05e2332&scoped=true"
import script from "./TestimonialsComp.vue?vue&type=script&lang=js"
export * from "./TestimonialsComp.vue?vue&type=script&lang=js"

import "./TestimonialsComp.vue?vue&type=style&index=0&id=b05e2332&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05e2332"]])

export default __exports__